import { render, staticRenderFns } from "./StaffDetailDialog.vue?vue&type=template&id=80cf290c&scoped=true"
import script from "./StaffDetailDialog.vue?vue&type=script&lang=js"
export * from "./StaffDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./StaffDetailDialog.vue?vue&type=style&index=0&id=80cf290c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cf290c",
  null
  
)

export default component.exports